<template>
  <v-dialog v-model="value"
            persistent
            scrollable
            :fullscreen="$vuetify.breakpoint.name === 'xs'"
            :max-width="maxWidth">
    <v-form ref="form"
            @submit="$emit('submit')"

            v-if="value">
      <v-card>
        <dialog-header :title="dialogTitle"
                       :close="close"/>

        <slot name="contentCard"/>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"
                 text @click.stop="close">
            {{ $t('actions.cancel') }}
          </v-btn>
          <v-btn
              class="ml-10"
              type="button"
              tile
              color="primary"
              dark
              @click="$emit('submit')"
              v-bind:loading="submitting"
              :disabled="saveDisabled">
            {{ $t('actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar
          v-model="validationsErrorsMessageVisible"
          :timeout="3000"
          centered
          :text="true">
        {{ validationMessage }}

        <template v-slot:action="{ attrs }">
          <v-btn
              color="black"
              icon
              v-bind="attrs"
              @click="validationsErrorsMessageVisible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-form>
  </v-dialog>


</template>

<script>
import DialogHeader from '@/components/layouts/DialogHeader';
export default {
  name: 'EntityEditDialog',
  components: { DialogHeader },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    submitting: {
      type: Boolean,
      required: true,
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    maxWidth: {
      type: Number,
      default: 800,
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    validationsErrorsMessageVisible: false,
    validationMessage: null,
  }),
  methods: {
    close() {
      this.$emit('close');
    },
    showFormHasValidationErrorsMessage(validationMessage) {
      this.validationMessage = validationMessage;
      this.validationsErrorsMessageVisible = true;
    },
  },
};
</script>
